import { useTranslation } from 'react-i18next';
import { AlertTriangle, RotateCw } from 'lucide-react';
import { Button } from '@/components/ui/Button';

interface ErrorStateProps {
  /** Qué no se pudo cargar («tus clientes», «las citas»…). */
  what?: string;
  onRetry?: () => void;
  retrying?: boolean;
  compact?: boolean;
}

/** Estado de ERROR de una carga: dice qué falló, que los datos no se perdieron
 *  y ofrece reintentar. Nunca se confunde con «vacío». */
export function ErrorState({ what, onRetry, retrying = false, compact = false }: ErrorStateProps) {
  const { t } = useTranslation();
  return (
    <div
      role="alert"
      data-testid="load-error"
      className={
        compact
          ? 'flex flex-wrap items-center gap-3 rounded-xl border border-danger/40 bg-danger/5 px-4 py-3 text-sm'
          : 'flex flex-col items-center justify-center rounded-2xl border border-danger/40 bg-danger/5 px-6 py-12 text-center'
      }
    >
      <AlertTriangle className={compact ? 'h-5 w-5 flex-none text-danger' : 'mb-3 h-8 w-8 text-danger'} aria-hidden="true" />
      <div className={compact ? 'min-w-0 flex-1' : ''}>
        <p className="font-semibold">{what ? t('loadState.errorTitleWhat', { what }) : t('loadState.errorTitle')}</p>
        <p className="mt-0.5 text-muted-foreground">{t('loadState.errorBody')}</p>
      </div>
      {onRetry && (
        <Button size="sm" variant="ghost" loading={retrying} onClick={onRetry} className={compact ? '' : 'mt-4'}>
          <RotateCw className="h-4 w-4" aria-hidden="true" />
          {t('loadState.retry')}
        </Button>
      )}
    </div>
  );
}
